import React, { useEffect } from "react";
import { Backdrop, CircularProgress, Stack, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../AccountAdmin/AdminCss/AdminDashboard.css";
import "bootstrap/dist/css/bootstrap.min.css";
import studenticon from "../../../assets/student-icon.svg";
import teachericon from "../../../assets/teacher-icon.svg";
import directpost from "../../../assets/direct-post-icon.svg";
import { adminDashboardData } from "../../features/admin/accountPostSlice";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isXs = useMediaQuery("(min-width:600px)");


  const dashboardDataGet = () => {
    dispatch(adminDashboardData());
  };

  useEffect(() => {
    dashboardDataGet();
  }, []);

  const handleNavigate = () =>{
      navigate('/dashboard/createPost');
  }

  const {dashboardData , loading} = useSelector((state) => state?.accountPost);


  return (
    <Stack sx={{ alignItems: isXs ? "" : "center" }}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress  color="inherit" />
      </Backdrop>
      <div className="bar">
        <span>Dashboard</span>
        <div className="search">
          <div className="right">
            <button onClick={handleNavigate} className="create-btn">+ Create Post</button>
          </div>
        </div>
      </div>
      <div className="container-2" style={{ padding: "0px 30px" }}>
        <div
          className="total-student-box"
          style={{ backgroundColor: "#6A73FA" }}
        >
          <img src={studenticon} alt="" id="student-icon" />
          <div className="total-student-text">
            <span>TOTAL STUDENTS</span>
            <span className="number-of-students">{dashboardData?.data?.studentCount}</span>
          </div>
        </div>
        <div
          className="total-student-box"
          style={{ backgroundColor: "#22C04F" }}
        >
          <img src={teachericon} alt="" id="student-icon" />
          <div className="total-student-text">
            <span>TOTAL TEACHERS</span>
            <span className="number-of-students">{dashboardData?.data?.teacherCount}</span>
          </div>
        </div>
        <div
          className="total-student-box"
          style={{ backgroundColor: "#FF1616" }}
        >
          <img src={directpost} alt="" id="student-icon" />
          <div className="total-student-text">
            <span>ACTIVE POST</span>
            <span className="number-of-students">{dashboardData?.data?.activePostCount}</span>
          </div>
        </div>
      </div>
    </Stack>
  );
};

export default AdminDashboard;
